import { SimpleTable } from '@/components/tables/simple-table'
import { Modal } from '../modal'
import { useCoursePreviewModal } from './hooks/use-course-preview-modal'

interface CoursePreviewModalProps {
  title: string
  curriculum?: string
  isOpen: boolean
  setOpen: (value: boolean) => void
}

export const CoursePreviewModal = ({
  isOpen,
  setOpen,
  title,
  curriculum
}: CoursePreviewModalProps) => {
  const {
    states: { coursesData, isCoursesLoading },
    actions: { createTable }
  } = useCoursePreviewModal(curriculum)

  const tableConfig = createTable(coursesData)

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      title={`Currículo: ${title}`}
      hiddenFooter={true}
      className="sm:max-w-none w-220"
      isLoading={isCoursesLoading}
    >
      <div className="w-full h-100 overflow-y-auto">
        <SimpleTable tableConfig={tableConfig} selectable={false} />
      </div>
    </Modal>
  )
}
